import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import appLogo from './../assets/images/svg/app-logo.svg';
import hamburger from './../assets/images/svg/hamburger.svg';
import closeIcon from './../assets/images/svg/close-icon.svg';
import { ContactArrow } from '../assets/images/components/ContactArrow';

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  // Close menu on window resize if desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1190) {
        setMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/expertise', label: 'Expertise' },
    { to: '/corporate', label: 'Corporates' },
    { to: '/lawyers', label: 'Lawyers' },
    { to: '/individuals', label: 'Individuals' },
    { to: '/about', label: 'About Us' },
    { to: '/contact-us', label: 'Contact Us' },
  ];

  return (
    <header className="header" data-aos="fade-up">
      <div className="logo">
        <Link to="/">
          <img src={appLogo} alt="appLogo" />
        </Link>
      </div>

      <div className={`nav ${isMenuOpen ? 'open' : ''}`}>
        {navLinks.map((link, index) => (
          <NavLink
            key={`nav-link-${link?.to}`}
            to={link.to}
            onClick={() => setMenuOpen(false)}
            className={`${link?.label == 'Contact Us' ? 'contact-nav' : ''}`}
          >
            {link.label !== 'Contact Us' ? (
              link.label
            ) : (
              <>
                {link.label}
                <ContactArrow />
              </>
            )}
          </NavLink>
        ))}
      </div>

      <button className="hamburger" onClick={() => setMenuOpen(!isMenuOpen)}>
        <img src={isMenuOpen ? closeIcon : hamburger} alt="Hamburger" />
      </button>
    </header>
  );
};

export default Header;
